<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-service'></i> 客服中心</el-breadcrumb-item>
                <el-breadcrumb-item>Q&amp;A分组</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='20'>
                        <el-form :inline='true' :model='queryParams' size='small'>
                            <el-form-item label='项目'>
                                <el-select v-model='queryParams.projectAppId' filterable clearable
                                           placeholder='请先选择项目' @change='handleProjectChange'>
                                    <el-option v-for='item in projectInfoList' :key='item.appId' :label='item.cnName'
                                               :value='item.appId' />
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type='primary' icon='el-icon-search' :disabled='!queryParams.projectAppId'
                                           @click='handleQuery'>刷新
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='4' class='table-actions'>
                        <el-button v-if='queryParams.projectAppId' type='primary' plain icon='el-icon-plus'
                                   @click='handleAdd'>新增
                        </el-button>
                    </el-col>
                </el-row>
            </div>
            
            <div v-if='queryParams.projectAppId'>
                <el-table ref='dataTable' v-loading='loading' :data='tableList' row-key='id'
                          :cell-style="{ textAlign: 'center' }" :header-cell-style="{ textAlign: 'center' }">
                    <el-table-column width='50' label=''>
                        <template><i class='el-icon-rank drag-handle'></i></template>
                    </el-table-column>
                    <el-table-column label='排序' prop='sort' width='80' />
                    <el-table-column label='分组名称'>
                        <template slot-scope='scope'>{{ getMappingPreview(scope.row.nameMapping) }}</template>
                    </el-table-column>
                    <el-table-column label='更新时间' prop='updateTime' show-overflow-tooltip />
                    <el-table-column label='操作' width='160' fixed='right'>
                        <template slot-scope='scope'>
                            <el-button type='text' icon='el-icon-edit' @click='handleUpdate(scope.row)'>修改</el-button>
                            <el-button type='text' icon='el-icon-delete' @click='handleDelete(scope.row)'>删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div class='pagination'>
                    <el-pagination
                        :current-page='queryParams.pageNum'
                        :page-size='queryParams.pageSize'
                        :total='queryParams.total'
                        background
                        layout='total, prev, pager, next'
                        @current-change='handlePagination'>
                    </el-pagination>
                </div>
            </div>
            <div v-else class='select-project-empty'>请先选择项目</div>
            
            <el-dialog :title='title' :visible.sync='open' append-to-body width='640px' :before-close='cancel'>
                <el-form ref='form' :model='form' label-width='90px'>
                    <el-form-item label='分组名称'>
                        <el-tabs v-model='activeLanguage'>
                            <el-tab-pane v-for='item in languageOptions' :key='item.value' :label='item.label'
                                         :name='item.value'>
                                <el-input v-model='form.nameMapping[item.value]'
                                          :placeholder='`请输入${item.label}分组名称`' />
                            </el-tab-pane>
                        </el-tabs>
                    </el-form-item>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确定</el-button>
                    <el-button @click='cancel'>取消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>
import { customerQaGroupApi } from '@api/customer';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';
import { message } from '@/utils/message';
import { deepCopy } from '@/utils/object';

export default {
    name: 'CustomerQaGroup',
    data() {
        return {
            loading: false,
            open: false,
            updateStatus: false,
            title: '',
            activeLanguage: 'zh-CN',
            tableList: [],
            projectInfoList: [],
            queryParams: {
                pageNum: 1,
                pageSize: 15,
                total: 0,
                projectAppId: undefined,
                sortSqlList: ['sort asc', 'id desc']
            },
            form: {
                nameMapping: {
                    'zh-CN': '',
                    'en-US': ''
                }
            },
            languageOptions: [
                { label: '简体中文', value: 'zh-CN' },
                { label: 'English', value: 'en-US' }
            ]
        };
    },
    created() {
        this.queryProjectList();
    },
    methods: {
        queryProjectList() {
            queryProjectInfoList({ pageSize: 100000 }).then(response => {
                if (response.code === 200 && response.data && response.data.result) {
                    this.projectInfoList = response.data.result;
                }
            });
        },
        getList() {
            if (!this.queryParams.projectAppId) {
                this.tableList = [];
                this.queryParams.total = 0;
                return;
            }
            this.loading = true;
            customerQaGroupApi.query(this.queryParams).then(response => {
                if (response.code === 200) {
                    this.tableList = response.data.result || [];
                    this.queryParams.total = response.data.total;
                    this.queryParams.pageNum = response.data.pageNum;
                    this.$nextTick(this.bindDrag);
                }
                this.loading = false;
            });
        },
        submitForm() {
            if (!this.hasMappingValue(this.form.nameMapping)) {
                message.error('请至少填写一个分组名称');
                return;
            }
            this.form.projectAppId = this.queryParams.projectAppId;
            const request = this.updateStatus ? customerQaGroupApi.update : customerQaGroupApi.insert;
            request(this.form).then(response => {
                if (response.code === 200) {
                    message.success(this.updateStatus ? '修改成功' : '新增成功');
                    this.open = false;
                    this.getList();
                }
            });
        },
        handleProjectChange() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        handleAdd() {
            if (!this.queryParams.projectAppId) {
                message.error('请先选择项目');
                return;
            }
            this.title = '新增Q&A分组';
            this.updateStatus = false;
            this.activeLanguage = 'zh-CN';
            this.form = {
                projectAppId: this.queryParams.projectAppId,
                sort: this.queryParams.total + 1,
                nameMapping: this.createEmptyMapping()
            };
            this.open = true;
        },
        handleUpdate(row) {
            this.title = '修改Q&A分组';
            this.updateStatus = true;
            this.activeLanguage = 'zh-CN';
            this.form = deepCopy(row);
            this.form.nameMapping = Object.assign(this.createEmptyMapping(), this.form.nameMapping || {});
            this.open = true;
        },
        handleDelete(row) {
            this.$confirm(`确认删除"${this.getMappingPreview(row.nameMapping)}"吗？`, '提示', { type: 'warning' }).then(() => {
                customerQaGroupApi.deleteData({ id: row.id }).then(response => {
                    if (response.code === 200) {
                        message.success('删除成功');
                        this.getList();
                    }
                });
            });
        },
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        cancel() {
            this.open = false;
        },
        createEmptyMapping() {
            const mapping = {};
            this.languageOptions.forEach(item => {
                mapping[item.value] = '';
            });
            return mapping;
        },
        hasMappingValue(mapping) {
            return mapping && Object.keys(mapping).some(key => mapping[key]);
        },
        getMappingPreview(mapping) {
            if (!mapping) {
                return '';
            }
            return mapping['zh-CN'] || mapping['en-US'] || Object.values(mapping).find(item => item) || '';
        },
        bindDrag() {
            const table = this.$refs.dataTable;
            if (!table || !table.$el) {
                return;
            }
            const rows = table.$el.querySelectorAll('.el-table__body-wrapper tbody tr');
            rows.forEach((row, index) => {
                row.draggable = true;
                row.dataset.index = index;
                row.ondragstart = event => {
                    event.dataTransfer.setData('text/plain', index);
                };
                row.ondragover = event => event.preventDefault();
                row.ondrop = event => {
                    event.preventDefault();
                    const oldIndex = Number(event.dataTransfer.getData('text/plain'));
                    const newIndex = Number(row.dataset.index);
                    this.handleDragSort(oldIndex, newIndex);
                };
            });
        },
        handleDragSort(oldIndex, newIndex) {
            if (oldIndex === newIndex || oldIndex < 0 || newIndex < 0) {
                return;
            }
            const list = this.tableList.slice();
            const moved = list.splice(oldIndex, 1)[0];
            list.splice(newIndex, 0, moved);
            const offset = (this.queryParams.pageNum - 1) * this.queryParams.pageSize;
            this.tableList = list.map((item, index) => Object.assign({}, item, { sort: offset + index + 1 }));
            this.tableList.forEach(item => customerQaGroupApi.update({ id: item.id, sort: item.sort }));
            this.$nextTick(this.bindDrag);
        }
    }
};
</script>

<style scoped>
.table-actions {
    text-align: right;
}

.drag-handle {
    cursor: move;
}

.select-project-empty {
    color: #909399;
    padding: 80px 0;
    text-align: center;
}
</style>
